/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useEffect, useRef, useState } from 'react';
import { WordCloud } from './chart';
import { WordCloudWidgetProps } from './types'
import { SubtitleCountRenderer } from 'components/virtualTooltip/renderers';
import { useVirtualTooltip } from 'components/virtualTooltip/useVirtualTooltip';

/**
 * WordCloud widget. See types.ts for more info about props.
 * @param dimensions {{height: height, width: width}} to define value of chart
 * @param data
 * @param widgetConfiguration
 */
export const WordCloudWidget = ({ dimensions, 
								  data,
								  widgetConfiguration }:WordCloudWidgetProps) => {
	const svgRef = useRef();
	const [cloud, setCloud]:
		  [ReturnType<typeof WordCloud>,any] = useState();

	// TODO: implement tooltip
	// const { TooltipElement, setTooltipData, setTooltipLocation, setTooltipOptions } = useVirtualTooltip(
	// 	SubtitleCountRenderer
	// );

	useEffect(() => {
		// const updateTooltip = (data, location, options) => {
		// 	setTooltipLocation(location);
		// 	setTooltipData(data);
		// 	setTooltipOptions(options);
		// };

		const createChart = () => {
			return WordCloud(svgRef.current, {});
		};

		if (data && dimensions && widgetConfiguration) {
			let ch = cloud;

			// if we don't have an existing chart, create one
			if (!ch) {
				ch = createChart();
				setCloud(ch);
			}

			ch.update(	widgetConfiguration,
						data,
						dimensions.height,
						dimensions.width);
		}
	}, [cloud, data, dimensions, widgetConfiguration]);

	return (
		<React.Fragment>
			<svg
				width={dimensions.width}
				height={dimensions.height}
			>
				<g ref={svgRef} />
			</svg>
		</React.Fragment>
	);
};